<template>

    <v-form class="mt-0 pt-0" v-model="validForm">
      <div>
        <v-text-field :placeholder="placeholder" v-model="identifier" :rules="identifierRules" ></v-text-field>
      </div>
      <div align="right">
        <v-btn type="submit" @click="submit" :disabled="!validForm">
          {{$t('go')}}
        </v-btn>
      </div>
    </v-form>

</template>

<script>

import Identifier from '@/views/login/components/Identifier';

export default {
  data: () => ({
    validForm: false,
    identifier: null,
    placeholder: 'you@example.com',
    // identifierRules: email || phone number || email with partner || phone number with partner
    identifierRules: [
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || /^\d{9,}$/.test(v) || /^[\w.-@]{3,}\/\w{3,8}$/.test(v) || /^\d{9,}\/\w{3,}$/.test(v)
    ],
  }),
  methods: {
    submit() { this.$emit('input', this.identifier); },
    changePlaceholder() { this.placeholder = ( this.placeholder==='you@example.com' ? '0836527195' : 'you@example.com' ); },
  },
  mounted: function () {
    window.setInterval(() => { this.changePlaceholder() }, 3000)
  },
};
</script>


<i18n>
{
  "en": {
    "go": "Go"
  },
  "es": {
    "go": "Ir"
  },
  "sw": {
    "go": "Nenda"
  }
}
</i18n>
